export const DARK_BLUE_BAND_CLASS = 'bg-button-primary text-white';

export const DARK_BLUE_BAND_MUTED_TEXT_CLASS = 'text-white/75';

export const DARK_BLUE_BAND_ICON_TILE_CLASS = 'bg-white/15 text-white ring-1 ring-white/25';

export const DARK_BLUE_BAND_SKELETON_CLASS = 'bg-white/25';
